import React from "react";
import { makeStyles, Slider, withStyles } from "@material-ui/core";
import {
  FastForward,
  FastRewind,
  Pause,
  PlayArrow,
  VolumeUp,
  VolumeOff,
  Fullscreen,
  FullscreenExit
} from "@material-ui/icons";

const useStyles = makeStyles({
  volumeSlider: {
    width: "100px",
    color: "#ffffff"
  },

  bottomIcons: {
    color: "#ffffff",
    padding: "12px 8px",

    "&:hover": {
      color: "#fff"
    }
  },
  controlContainer: {
    backgroundColor: "rgba(0,0,0,0.6)",
    position: "absolute",
    top: "0",
    bottom: "0",
    right: "0",
    left: "0",
    flexDirection: "column",
    zIndex: "1",
    display: "flex",
    justifyContent: "space-between"
  },
  topContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "5px 20px"
  },
  midContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  iconBtn: {
    padding: "0px 10px",
    color: "#ffffff"
  },
  sliderContainer: {
    display: "flex",
    alignItems: "center",
    padding: "0px 16px"
  },
  controlBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 0.5rem"
  },
  innerControls: {
    display: "flex",
    padding: "10px 0px",
    alignItems: "center",
    width: "50%"
  },
  span: {
    color: "#ffffff",
    fontSize: "0.8rem",
    marginLeft: "10px"
  },
  secondControl: {
    display: "flex",
    alignItems: "center"
  }
});

const PrettoSlider = withStyles({
  root: {
    height: "20px",
    color: "#ffffff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  thumb: {
    height: 20,
    width: 20,
    backgroundColor: "#ffffff",
    border: "2px solid currentColor",
    marginTop: -3,
    marginLeft: -12,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit"
    }
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 4px)"
  },
  track: {
    height: 5,
    borderRadius: 4,
    width: "100%"
  },
  rail: {
    height: 5,
    borderRadius: 4
  }
})(Slider);

const Control = ({
  onPlayPause,
  playing,
  canRewind,
  canFastForward,
  onRewind,
  onForward,
  played,
  onSeek,
  onSeekMouseUp,
  onVolumeChangeHandler,
  onVolumeSeekUp,
  volume,
  mute,
  onMute,
  fullscreen,
  onFullscreen,
  duration,
  currentTime,
  onMouseSeekDown,
  controlRef
}) => {
  const classes = useStyles();

  return (
    <div className={classes.controlContainer} ref={controlRef}>
      <div className={classes.topContainer} />
      <div className={classes.midContainer}>
        <div className={classes.iconBtn}>
          {canRewind && <FastRewind onDoubleClick={onRewind} />}
        </div>
        <div className={classes.iconBtn} onClick={onPlayPause}>
          {playing ? <Pause /> : <PlayArrow />}{" "}
        </div>
        <div className={classes.iconBtn}>
          {canFastForward && <FastForward onDoubleClick={onForward} />}
        </div>
      </div>
      <div className="bottom__container">
        <div className={classes.sliderContainer}>
          <PrettoSlider
            min={0}
            max={100}
            value={played * 100}
            onChange={onSeek}
            onChangeCommitted={onSeekMouseUp}
            onMouseDown={onMouseSeekDown}
          />
        </div>
        <div className={classes.controlBox}>
          <div className={classes.innerControls}>
            <div className={classes.iconBtn} onClick={onPlayPause}>
              {playing ? <Pause /> : <PlayArrow />}{" "}
            </div>

            <div className={classes.iconBtn} onClick={onMute}>
              {mute ? <VolumeOff /> : <VolumeUp />}
            </div>

            <Slider
              className={classes.volumeSlider}
              onChange={onVolumeChangeHandler}
              value={volume * 100}
              onChangeCommitted={onVolumeSeekUp}
            />

            <span className={classes.span}>
              {currentTime} : {duration}
            </span>
          </div>
          <div className={classes.innerControls} style={{ justifyContent: "flex-end" }}>
            <div className={classes.iconBtn} onClick={onFullscreen}>
              {fullscreen ? <FullscreenExit /> : <Fullscreen />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Control;
